import { ItemEditContent } from "@eusoft/webapp-framework";
import { formatText, required } from "@eusoft/webapp-ui";
import { entityItemsSource } from "../../helpers/ItemsSources";
import { Authorize } from "../../services/Authorize";
import { context } from "../../services/Context";
import { executeAsync } from "../../services/DataService";
import type { Guid, ICreateCatalog } from "../../entities/Commands";
import type { IItemEditArgs } from "@eusoft/webapp-framework";

export interface ICreateCatalogArgs extends IItemEditArgs<ICreateCatalog> {
    saleCircuitId: Guid;
    merchantId: Guid;
}

export const CreateCatalogPage = ItemEditContent.bulder<ICreateCatalog, ICreateCatalogArgs>()

    .info({
        name: "catalog-create",
        route: "/catalog/create",
    })

    .options(()=>({
        style: "panel",
        title: formatText("create-item", "catalog")
    }))

    .feature(Authorize(bld =>
        bld.businessAccount()
            .resource("ProductCatalog", "create")))

    .save(async value => {

        const id = await executeAsync("CreateCatalog", value);
        return true;
    })

    .load(async args => {

        args.value = {
            merchantId: args.merchantId ?? context.merchant?.id
        } as ICreateCatalog;

        return true;
    })

    .editor(bld => <>

        {bld.singleSelector(a => a.merchantId, {
            validators: [required],
            label: "merchant",
            editor: {
                itemsSource: entityItemsSource("ListMerchant")
            }
        })}

        {bld.text(a => a.name, {
            validators: [required]
        })}

    </>, {
        commitMode: "manual",
        style: "vertical",
        inputField: { style: "filled" },
    })
    .asContent();

